import Link from 'next/link';
import Image from 'next/image';
import { PostData, getCtaLabel, getPostHref, getTypeBadgeLabel } from './types';

export const HORIZONTAL_GRID_CLASS =
  'grid grid-cols-1 gap-[14px] lg:grid-cols-2';

export function HorizontalResourceCard({ post }: { post: PostData }) {
  return (
    <Link
      href={getPostHref(post)}
      className="group flex flex-col overflow-hidden rounded-2xl bg-[#f2f2f2] transition-shadow hover:shadow-md sm:flex-row h-full"
    >
      {/* Thumbnail */}
      <div className="relative aspect-video w-full shrink-0 overflow-hidden sm:aspect-auto sm:w-[45%]">
        {post.image ? (
          <Image
            src={post.image}
            alt={post.imageAlt || post.title}
            fill
            className="absolute inset-0 size-full object-cover transition-transform duration-300 group-hover:scale-105"
            sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
          />
        ) : (
          <div className="flex size-full items-center justify-center bg-gray-100">
            <span className="text-sm text-gray-400">No image</span>
          </div>
        )}
      </div>

      {/* Body */}
      <div className="flex flex-1 flex-col gap-4 p-4">
        {/* Type kicker with vertical accent bar */}
        <div className="flex items-center gap-3 border-l-2 border-[#4b0fea] pl-3">
          <span className="text-[12px] font-semibold uppercase tracking-wide text-[#041118]">
            {getTypeBadgeLabel(post.type)}
          </span>
        </div>

        {/* Topic pill */}
        {post.categoryName && (
          <span className="inline-flex w-fit rounded-md bg-white px-3 py-1.5 text-[12px] font-semibold uppercase tracking-wide text-[#041118]">
            {post.categoryName}
          </span>
        )}

        {/* Title */}
        <h3 className="line-clamp-3 text-[24px] font-semibold leading-[1.25] text-[#041118]">
          {post.title}
        </h3>

        {/* CTA button */}
        <span className="mt-auto inline-flex w-fit rounded-lg border border-[#041118] px-6 py-3 text-[16px] font-medium text-[#262626] transition-colors group-hover:bg-[#041118]/5">
          {getCtaLabel(post.type)}
        </span>
      </div>
    </Link>
  );
}
